// https://www.badtz-ui.com/docs/components/infinite-ribbon
import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils/cn';

interface InfiniteRibbonProps extends VariantProps<typeof ribbonVariants> {
  repeat?: number;
  duration?: number;
  reverse?: boolean;
  rotation?: number;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const ribbonVariants = cva('max-w-full overflow-hidden py-1 text-lg', {
  variants: {
    variant: {
      primary: 'bg-primary-lighter text-primary-dark',
      accent: 'bg-accent-lighter text-accent-dark',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export function InfiniteRibbon({
  repeat = 5,
  duration = 10,
  reverse = false,
  rotation = 0,
  children,
  className,
  variant,
  onClick,
}: InfiniteRibbonProps) {
  const animationClass = reverse ? 'animate-infinite-ribbon-reverse' : 'animate-infinite-ribbon';

  return (
    <div
      className={cn(ribbonVariants({ variant }), onClick ? 'cursor-pointer' : '', className)}
      style={{ transform: `rotate(${rotation}deg)` }}
      onClick={onClick}
    >
      <div className={cn('flex whitespace-nowrap', animationClass)} style={{ '--ribbon-duration': `${duration}s` } as React.CSSProperties}>
        {Array.from({ length: repeat }, (_, index) => (
          <span key={index} className="mr-8 inline-block select-none">
            {children}
          </span>
        ))}
      </div>
    </div>
  );
}

export default InfiniteRibbon;
